export default {
  browse: {
    title: "Explorar",
    sections: {
      advancedTools: "Herramientas avanzadas",
      freeTools: "Herramientas gratis",
    },
    gamesOfPeriod: "Partidos del {{period}}",
    periods: {
      day: "día",
      week: "semana",
    },
    gameCount_one: "{{count}} Partido",
    gameCount_other: "{{count}} Partidos",
  },
};